import { render, staticRenderFns } from "./importTable.vue?vue&type=template&id=5a7b7644&scoped=true"
import script from "./importTable.vue?vue&type=script&lang=js"
export * from "./importTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7b7644",
  null
  
)

export default component.exports